import { useState } from 'react';

function usePagination10(totalItems, initialRowsPerPage = 10) {
    const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);
    const [currentPage, setCurrentPage] = useState(1); // Página atual

    const totalPages = Math.ceil(totalItems / rowsPerPage);

    // Calcula o startIndex com base na página atual
    const startIndex = (currentPage - 1) * rowsPerPage;

    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const goToFirstPage = () => goToPage(1);
    const goToPreviousPage = () => goToPage(currentPage - 1);
    const goToNextPage = () => goToPage(currentPage + 1);
    const goToLastPage = () => goToPage(totalPages);

    const resetPage = () => setCurrentPage(1);

    return {
        setPagination: {
            totalItems,
            rowsPerPage,
            startIndex,
            currentPage,
            totalPages,
            resetPage,
            onRowsPerPageChange: (e) => {
                setRowsPerPage(Number(e.target.value));
                setCurrentPage(1);
            },
            onFirstItems: goToFirstPage,
            onPreviousItems: goToPreviousPage,
            onNextItems: goToNextPage,
            onLastItems: goToLastPage,
            onGoToPage: goToPage,
        },
    };
}

export default usePagination10;